<template>
  <loader v-bind="{ loading }">
    <message v-if="!user.two_factor_is_setup" class="is-danger">
      <p>
        Two Factor Authentication is not current enabled. Please enable 2FA to secure your account.
        <router-link :to="{
          name: 'account'
        }">Secure Your Account</router-link>  
      </p>
      
    </message>
    <message v-if="isOnTrial && !account.subscription.id" class="is-warning">
      <p>
        Your trail will expire in {{ trialExpireyDays }} day{{ trialExpireyDays !== 1 ? 's' : '' }}.
        <router-link :to="{
          name: 'plans'
        }">Upgrade to a Paid Plan</router-link>
      </p>
      
    </message>
    <div class="columns">
      <div class="column">
        <columns>
          <column>
            <div class="box is-fullheight">
              <p class="is-flex justify-between"><span>Apps</span> <span>{{ dashboard.count.apps }}</span></p>
              <p class="is-flex justify-between"><span>Environments</span> {{ dashboard.count.environments }}</p>
              <p class="is-flex justify-between"><span>Vulnerable Environments</span> {{ dashboard.count.vulnerable_environments }}</p>
              <p class="is-flex justify-between"><span>Operations</span> {{ accountOverview.operations.total }}</p>
            </div>
          </column>
          <column>
            <div class="box is-fullheight">
              <p class="is-flex justify-between"><span>Events</span> {{ dashboard.count.security_events }}</p>
              <p class="is-flex justify-between"><span>Events This Month</span> {{ dashboard.count.security_events_this_month }}</p>
              <p class="is-flex justify-between"><span>Operations</span> {{ accountOverview.operations.total }}</p>
            </div>
          </column>
        </columns>

        <div class="box">
          <columns>
            <column>
              <p class="is-size-4">Operations run in this month</p>
                <h1 class="is-size-1 has-text-weight-light is-marginless is-paddingless">
                  {{ accountOverview.operations.for_the_month | toFixed }}
                </h1>
                <p class="is-flex">
                  <span :class="{
                      'has-text-danger': thisMonthsOpsVsLastMonth <= 0,
                      'has-text-success': thisMonthsOpsVsLastMonth > 0,
                    }" class="is-flex">
                    <icon :icon="thisMonthsOpsVsLastMonth > 0 ? 'arrow-up' : 'arrow-down'"/>
                    <span>{{ thisMonthsOpsVsLastMonth + '%' }}</span>
                  </span>
                  <span class="ml">from last month</span>
                </p>
            </column>
          </columns>
        </div>
      </div>
      <div class="column">
        <div class="box is-fullheight">
          <div class="columns">
            <div class="column is-6">
              <version-spread-donut class="donut-chart" :spread="dashboard.laravel_versions" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </loader>
</template>

<script>
import { getPath } from '@/api/common'
import { mapGetters } from 'vuex'
import VersionSpreadDonut from '@/components/charts/VersionSpreadDonut'
import moment from 'moment'

export default {

  components: {
    VersionSpreadDonut
  },

  name: 'Dashboard',


  data: () => ({
    dashboard: {
      count: {
        apps: 0
      },
      laravel_versions: []
    },
    loading: true
  }),

  created() {
    this.$bus.$emit('set-title', 'Dashboard')

    Promise.all([
      this.$store.dispatch('auth/loadAccountOverview'),
      getPath({
        path: 'api/dashboard'
      }, ({data}) => {
        this.dashboard = data
      })
    ]).then(() => {
      this.loading = false
    })
  },

  computed: {
    ...mapGetters('auth', [
      'user',
      'account',
      'plans',
      'accountOverview',
    ]),
    month() {
      return moment().format('MMMM')
    },
    trialExpireyDays() {
      let now = moment()
      let expires = moment(this.account.expires_at)
      return expires.diff(now, 'days')
    },
    isOnTrial() {
      return new Date(this.account.expires_at) > new Date()
    },
    operationsRunLastMonth() {
      return this.accountOverview.operations.for_last_month
    },
    operationsThisTimeLastMonth() {
      return this.accountOverview.operations.this_time_last_month
    },
    operationsRunThisMonth() {
      return this.accountOverview.operations.for_the_month
    },
    thisMonthsOpsVsLastMonth() {
      if(this.operationsThisTimeLastMonth === 0 && this.operationsRunThisMonth === 0) return 0

      if(this.operationsThisTimeLastMonth === 0 && this.operationsRunThisMonth > 0) return 100

      if(this.operationsThisTimeLastMonth > 0 && this.operationsRunThisMonth > 0) {
        return (100 - ((this.operationsThisTimeLastMonth / this.operationsRunThisMonth) * 100)).toFixed(2)
      }

      return 0
    }
  }

}
</script>
